import { FormattedMessage, useIntl } from "react-intl";
import { NoBackend } from "@/components/common/NoBackend";
import { userErrorMessage } from "@/lib/user-error";

// What a Share detail page shows instead of its record: still loading, failed, or not there. genesis
// answers null both for "does not exist" and "not shared with you", so "not found" covers both.
// Shared by the post and the project page so the two read the same (spark#1001).
export function ShareDetailStatus({
  loading,
  error,
  notFoundLabel,
  notFoundId,
}: {
  loading: boolean;
  error: unknown;
  notFoundLabel: string;
  notFoundId?: string;
}) {
  const intl = useIntl();
  if (loading) {
    return (
      <div className="text-smycles-label text-ink-muted">
        <FormattedMessage id="share.itemDetail.loading" defaultMessage="loading…" />
      </div>
    );
  }
  if (error) {
    return (
      <div className="text-smycles-label text-ink-muted">
        <FormattedMessage
          id="share.itemDetail.error"
          defaultMessage="Error: {message}"
          values={{ message: userErrorMessage(intl, error) }}
        />
      </div>
    );
  }
  return <NoBackend id={notFoundId} label={notFoundLabel} />;
}
